import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useEffect, useState } from 'react';
import { modules } from 'const';
import { useAppRouter } from 'utils/AppRouteProvider';
var Title = _Typography.Title,
  Paragraph = _Typography.Paragraph;
var LandingPage = function LandingPage() {
  var _useAppRouter = useAppRouter(),
    navigateTo = _useAppRouter.navigateTo;
  var _useState = useState(false),
    shouldRenderLandingPage = _useState[0],
    setShouldRenderLandingPage = _useState[1];
  var optionRowStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  };
  var optionTextStyle = {
    flex: '1 1 320px',
    margin: 0,
    fontSize: 16
  };
  var optionButtonStyle = {
    width: '220px',
    minHeight: '56px',
    whiteSpace: 'normal',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
  var introTextStyle = {
    fontSize: 16,
    textAlign: 'center',
    fontStyle: 'italic'
  };
  useEffect(function () {
    var fetchLastVisitedPage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var lastVisitedPage;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return localStorage.getItem('lastVisitedPage');
            case 2:
              lastVisitedPage = _context.sent;
              if (lastVisitedPage) {
                navigateTo(lastVisitedPage);
              } else {
                setShouldRenderLandingPage(true);
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchLastVisitedPage() {
        return _ref.apply(this, arguments);
      };
    }();
    fetchLastVisitedPage();
  }, []);
  if (shouldRenderLandingPage) {
    return __jsx("div", {
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: '24px'
      }
    }, __jsx(_Card, {
      style: {
        width: '100%',
        maxWidth: '900px'
      },
      bordered: true
    }, __jsx(_Space, {
      direction: "vertical",
      size: "large",
      style: {
        width: '100%'
      }
    }, __jsx("div", {
      style: {
        textAlign: 'center',
        width: '100%'
      }
    }, __jsx(Title, {
      level: 2,
      style: {
        marginBottom: 0
      }
    }, "Welcome to Trailmaker!")), __jsx(_Space, {
      direction: "vertical",
      size: "large",
      style: {
        width: '100%'
      }
    }, __jsx(Paragraph, {
      style: introTextStyle
    }, "To get started, select from the following 4 options:"), __jsx("div", {
      style: optionRowStyle
    }, __jsx(Paragraph, {
      style: optionTextStyle
    }, "Looking for the Sample Loading Table to start barcoding?"), __jsx(_Button, {
      size: "large",
      type: "primary",
      style: optionButtonStyle,
      onClick: function onClick() {
        return navigateTo(modules.SAMPLE_LOADING_TABLE);
      }
    }, "Take me to Sample Loading Table")), __jsx("div", {
      style: optionRowStyle
    }, __jsx(Paragraph, {
      style: optionTextStyle
    }, "Want to start exploring our data analysis tool with public data?"), __jsx(_Button, {
      size: "large",
      type: "primary",
      style: optionButtonStyle,
      onClick: function onClick() {
        return navigateTo(modules.REPOSITORY);
      }
    }, "Take me to Repository")), __jsx("div", {
      style: optionRowStyle
    }, __jsx(Paragraph, {
      style: optionTextStyle
    }, "Ready to start processing Parse Biosciences FASTQ files?"), __jsx(_Button, {
      size: "large",
      type: "primary",
      style: optionButtonStyle,
      onClick: function onClick() {
        return navigateTo(modules.SECONDARY_ANALYSIS);
      }
    }, "Take me to Pipeline")), __jsx("div", {
      style: optionRowStyle
    }, __jsx(Paragraph, {
      style: optionTextStyle
    }, "Ready to start exploring processed data files, such as count matrices or a Seurat object?"), __jsx(_Button, {
      size: "large",
      type: "primary",
      style: optionButtonStyle,
      onClick: function onClick() {
        return navigateTo(modules.DATA_MANAGEMENT);
      }
    }, "Take me to Insights"))))));
  }
};
export default LandingPage;